/**
 * 生产质量监控大屏：后端字段 → 页面展示结构（与 productionQualityControl.vue 配套）
 */

export function sectionTabsWithAll (rows) {
  const list = Array.isArray(rows) ? rows : []
  const tabs = list.map((item) => ({ id: String(item.id), name: item.name }))
  return [{ id: 'ALL', name: '全部' }, ...tabs]
}

export function mapQualityStats (raw) {
  if (!raw) {
    return {
      firstPassRate: 0,
      rectificationOrders: 0,
      rectificationDoneRate: 0,
      failedInspectionCount: 0,
      processWarningCount: 0
    }
  }
  return {
    firstPassRate: Number(raw.onceCheckPassRate) || 0,
    rectificationOrders: Number(raw.rectificationWorkOrderCount) || 0,
    rectificationDoneRate: Number(raw.qualityCompletionRate) || 0,
    failedInspectionCount: Number(raw.checkUnqualifiedCount) || 0,
    processWarningCount: Number(raw.processWarningCount) || 0
  }
}

export function mapWorkOrdersProportion (data) {
  let pairs = []
  if (Array.isArray(data)) {
    pairs = data.map((item) => [
      item.name || item.processName || item.label || '',
      Number(item.value ?? item.count ?? item.num ?? 0) || 0
    ])
  } else if (data && typeof data === 'object') {
    pairs = Object.keys(data)
      .filter((k) => typeof data[k] === 'number' || (data[k] != null && !Number.isNaN(Number(data[k]))))
      .map((k) => [k, Number(data[k]) || 0])
  }
  const items = pairs
    .filter(([, v]) => v >= 0)
    .map(([name, value]) => ({ name, value, percent: 0 }))
  const total = items.reduce((s, i) => s + i.value, 0)
  items.forEach((i) => {
    i.percent = total ? Math.round((i.value / total) * 100) : 0
  })
  return { totalOrders: total, items }
}

function mapBeamFieldStatus (text) {
  const t = String(text || '')
  if (t.includes('生产完成')) {
    return 'done'
  }
  if (t.includes('待生产')) {
    return 'pending'
  }
  return 'producing'
}

export function mapSectionTable (list) {
  if (!Array.isArray(list)) {
    return []
  }
  return list.map((row) => ({
    sectionName: row.beamSectionConfigName || '',
    totalPlan: Number(row.totalPlanProduction) || 0,
    cumulativeInspection: Number(row.totalCheck) || 0,
    inspectionProgressPercent: Number(row.checkProgress) || 0,
    firstPassCount: Number(row.firstPassQualified) || 0,
    firstPassPercent: Number(row.firstPassRate) || 0,
    firstFailCount: Number(row.firstPassUnqualified) || 0,
    erectionPercent: Number(row.erectionProgress) || 0,
    yardStatus: mapBeamFieldStatus(row.beamFieldStatus)
  }))
}

export function mapUnqualifiedRanking (list) {
  if (!Array.isArray(list)) {
    return []
  }
  return list.map((row, idx) => ({
    rank: idx + 1,
    label: row.targetName || '',
    count: Number(row.unqualifiedCount) || 0,
    percent: Number(row.unqualifiedRatio) || 0
  }))
}

export function mapWarningStats (raw) {
  if (!raw) {
    return []
  }
  return [
    { key: 'curing', label: '养护时长不足12小时', count: Number(raw.yhCount) || 0 },
    { key: 'grout', label: '压浆完成静置时长不足48小时', count: Number(raw.yjCount) || 0 },
    { key: 'tension', label: '张拉伸长量偏差率大于±6%', count: Number(raw.zlCount) || 0 }
  ]
}
